import {defineStore} from 'pinia'
import type {IAdminAutomationsStore} from "@app/types";
import {AutomationTypeEnum, type ISmsAutomation} from "@torim-app/types";
import {CommunicationApi} from "@app/api/admin";

export const useAdminAutomations = defineStore('admin-automations', {
  state: (): IAdminAutomationsStore => ({
    automations: <ISmsAutomation[]>[],
    nudgeCount: 0,
    automationConfigs: null,
  }),
  getters: {
    getAutomations(state): ISmsAutomation[] {
      return state.automations;
    },
    isCancellationAutomationEnabled(state): boolean {
      return !!state.automationConfigs?.find(c => c.type === AutomationTypeEnum.BookingCanceled)?.enabled;
    },
  },
  actions: {
    async fetchAllAutomations() {
      try {
        this.automations = await CommunicationApi.fetchAutomations();
      } catch (e) {
        console.error(e)
        throw e;
      }
    },
    async fetchNudgeCount() {
      try {
        const suggestions = await CommunicationApi.fetchSmartNudgeSuggestions();
        this.nudgeCount = suggestions.length;
      } catch { /* ignore */ }
    },
    async fetchAutomationConfigs() {
      try {
        this.automationConfigs = await CommunicationApi.fetchAutomationConfigs();
      } catch { /* ignore */ }
    },
  }
})
